import axios from 'axios'
import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import BadgeCinestar from '../../components/Badges/BadgeCinestar/BadgeCinestar'
import ButtonCinestar from '../../components/Buttons/ButtonCinestar/ButtonCinestar'
import AnchorLink from '../../components/Buttons/ButtonLink/AnchorLink'
import ButtonLink from '../../components/Buttons/ButtonLink/ButtonLink'
import ButtonRefreshment from '../../components/Buttons/ButtonRefreshment/ButtonRefreshment'
import ButtonSocialLogin from '../../components/Buttons/ButtonSocialLogin/ButtonSocialLogin'
import ButtonTime from '../../components/Buttons/ButtonTime/ButtonTime'
import DropdownLayout from '../../components/Dropdowns/DropdownLayout/DropdownLayout'
import ProgramTime from '../../components/Dropdowns/ProgramTime/ProgramTime'
import FormLayout from '../../components/Forms/FormLayout/FormLayout'
import Checkbox from '../../components/Inputs/Checkbox/Checkbox'
import InputEmail from '../../components/Inputs/InputEmail/InputEmail'
import InputPassword from '../../components/Inputs/InputPassword/InputPassword'
import InputPhone from '../../components/Inputs/InputPhone/InputPhone'
import InputText from '../../components/Inputs/InputText/InputText'
import Radio from '../../components/Inputs/Radio/Radio'
import RadioGroup from '../../components/Inputs/RadioGroup/RadioGroup'
import OrderStepsHeader from '../../components/OrderStepsHeader/OrderStepsHeader'
import Seat from '../../components/Seat/Seat'
import Ticket from '../../components/Ticket/Ticket'
import ToggleButtonRow from '../../components/ToggleButtonRow/ToggleButtonRow'
import Tooltip from '../../components/Tooltip/Tooltip'
import Typography from '../../components/Typography/Typography'
import ErrorWindow from '../../components/Windows/ErrorWindow/ErrorWindow'
import TicketTypes from '../../components/Windows/InfoWindow/components/TicketTypes/TicketTypes'
import InfoWindow from '../../components/Windows/InfoWindow/InfoWindow'

import { TOGGLE_BUTTONS_TEXT } from '../../components/ToggleButtonRow/components/ToggleButton/constants'

function Demo() {
    const [payByPoints, setPayByPoint] = useState(false)
    const [toggleBtnTextActive, setToggleBtnTextActive] = useState('basic')
    const [toggleBtnIconActive, setToggleBtnIconActive] = useState('credit')
    const intl = useIntl()

    const getMovies = async () => {
        const options = {
            method: 'POST',
            url: 'https://test.cinestar.digital.cz/api',
            data: {
                query: `{
  moviesEntries {
    title,
    uri,
    Duration,
    TitleArray,
    Premiere,
    PictureUrl,
    Movie3D,
    Accessibility,
  }
}`,
            },
        }
        axios
            .request(options)
            .then(function (response) {
                const res = response.data // Response received from the API
                console.log('GraphQL: ', res) // TODO: Remove when no longer needed
            })
            .catch(function (error) {
                console.error(error)
            })
    }

    return (
        <div className="d-flex flex-column align-items-center w-100 gap-3">
            <button onClick={getMovies}>GRAPHQL</button>

            <Container className={'bg-basePrimary py-3 d-flex align-items-center justify-content-center'}>
                <h1 className={'text-white'}>{intl.formatMessage({ id: 'demo.title' })}</h1>
            </Container>
            <Container className="border-top py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Badges:</h2>
                <BadgeCinestar>PREMIERA</BadgeCinestar>
                <BadgeCinestar type="outline">140 min</BadgeCinestar>
                <BadgeCinestar type="outline">P</BadgeCinestar>
            </Container>

            <Container className="border-top py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Information Windows:</h2>
                <InfoWindow title="blue" color="blue" element={<TicketTypes />} onClose />
                <InfoWindow
                    title="purple"
                    color="purple"
                    description={'Na toto představení není možné využít body z věrnostního programu Cinestar Club.'}
                />
                <InfoWindow
                    title="green"
                    color="green"
                    description={'Rezervaci zaplatíte na pokladně, kiosku nebo prostřednictvím mobilní aplikace.'}
                />
                <InfoWindow
                    title="red"
                    color="red"
                    description={
                        'Nezapomeňte si rezervaci vyzvednout v kiosku nebo na pokladně kina, alespoň 30 minut předpředstavením.'
                    }
                />
                <InfoWindow
                    title="white"
                    color="white"
                    description={'Z technických důvodů lze platit pouze platebními kartami.'}
                />
                <InfoWindow
                    title="transparent"
                    color="transparent"
                    description={'Rezervaci zaplatíte na pokladně, kiosku nebo prostřednictvím mobilní aplikace.'}
                />
            </Container>

            <Container className="border-top py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Error Windows:</h2>
                <ErrorWindow
                    title={intl.formatMessage({ id: 'windows.error.payment.title' })}
                    description={intl.formatMessage({ id: 'windows.error.payment.description' })}
                    textButton1={intl.formatMessage({ id: 'windows.error.payment.button1' })}
                    textButton2={intl.formatMessage({ id: 'windows.error.payment.button2' })}
                />
                <ErrorWindow
                    title={intl.formatMessage({ id: 'windows.error.limit.title' })}
                    description={intl.formatMessage({ id: 'windows.error.limit.description' })}
                    textButton1={intl.formatMessage({ id: 'windows.error.limit.button' })}
                />
            </Container>

            <Container className="border-top py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Order Steps:</h2>
                <OrderStepsHeader page={'hall'} />
            </Container>
            <Container className="border-top py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Seats:</h2>
                <Seat />
                <Seat size="double" />
                <Seat type="wheelchair" />
                <Seat type="positionable" />
                <Seat type="vip" />
                <Seat type="reserved" />
                <Seat type="reserved" size="double" />
            </Container>

            <Container className="border-top py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Buttons:</h2>
                <ButtonTime time={'17:30'} disabled />
                <ButtonTime time={'22:30'} onClick={() => alert('click')} />
                <ButtonRefreshment />
                <ButtonCinestar variant="primary-v1">CineStar P-v1</ButtonCinestar>
                <ButtonCinestar variant="primary-v2">CineStar P-v2</ButtonCinestar>
                <ButtonCinestar variant="secondary">CineStar S</ButtonCinestar>
                <ButtonCinestar
                    variant="secondary"
                    iconLeft="arrow-left"
                    onClick={() => {
                        alert('Clicked')
                    }}
                >
                    CineStar S icon
                </ButtonCinestar>
                <ButtonCinestar
                    variant="secondary"
                    iconRight="chevron–down"
                    onClick={() => {
                        alert('Clicked')
                    }}
                >
                    CineStar S icon
                </ButtonCinestar>
                <ButtonLink onClick={() => alert('click')}>Button Link</ButtonLink>
                <AnchorLink href={'https://www.youtube.com/'}>Anchor Link</AnchorLink>
                <ButtonSocialLogin variant="facebook" />
                <ButtonSocialLogin variant="google" />
                <ButtonSocialLogin variant="apple" />
            </Container>

            <Container className="border-top py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Dropdowns:</h2>
                <ProgramTime />
                <DropdownLayout className={'py-3 text-white'}>Dropdown Layout</DropdownLayout>
            </Container>

            <FormLayout className="bg-basePrimary py-3 d-flex flex-column align-items-center gap-3">
                <h2 className="text-white">Inputs:</h2>
                <InputText placeholder="Jméno" errorText="Error text" name="firstName" />
                <InputEmail label="Label" placeholder="Placeholder" name="firstName" />
                <InputPassword label="Label" placeholder="Placeholder" name="firstName" />
                <InputPhone placeholder="XXX XXX XXX" errorText="Error text" label="Telefon" />
                <Checkbox label="Agree to terms and conditions" errorText="You must agree before submitting." />
                <RadioGroup label={'Gender'}>
                    <Radio label="Man" value="man" name={'gender'} />
                    <Radio label="Woman" value="woman" name={'gender'} />
                    <Radio label="Other" value="other" name={'gender'} defaultChecked />
                </RadioGroup>
                <RadioGroup label={'Gender with error'} error={'asdadsas'}>
                    <Radio label="Man" value="man" error={'error'} name={'gender-error'} />
                    <Radio label="Woman" value="woman" error={'error'} name={'gender-error'} />
                    <Radio label="Other" value="other" error={'error'} name={'gender-error'} defaultChecked />
                </RadioGroup>
            </FormLayout>

            <Container className={'bg-basePrimary py-3 d-flex flex-column align-items-center gap-3'}>
                <Tooltip id={'test-tooltip'} content={'Hello world'} placement={'top'} />
                <Tooltip id={'test-tooltip3'} content={'Hello world 3'} placement={'bottom'} clickable />
            </Container>

            <Container className={'bg-basePrimary py-3 mb-3 d-flex flex-column align-items-center gap-3'}>
                <h3 className={'text-white'}>{'Tickets'}</h3>
                <Ticket seat={{ type: 'classic', number: 'M 10' }} price={{ amount: 189, currency: 'CZK' }} />
                <Ticket seat={{ type: 'vip', number: 'B 38' }} price={{ amount: 250, currency: 'CZK' }} />
                <Ticket seat={{ type: 'positionable', number: 'P 10' }} price={{ amount: 229, currency: 'CZK' }} />
                <Ticket seat={{ type: 'wheelchair', number: 'W 05' }} price={{ amount: 169, currency: 'CZK' }} />
                <Ticket
                    seat={{ type: 'vip', number: 'B 40' }}
                    price={{ amount: 250, currency: 'CZK' }}
                    type={'basic'}
                    isPayment
                    isPayedWithPoints={payByPoints}
                    onPointPaymentSelect={setPayByPoint}
                />
                <Ticket
                    seat={{ type: 'vip', number: 'B 40' }}
                    price={{ amount: 250, currency: 'CZK' }}
                    type={'basic'}
                    isPayment
                    disabledPointPayment
                />
            </Container>

            <Container className={'py-3 d-flex flex-column align-items-center gap-3 mb-3'}>
                <ToggleButtonRow
                    btns={TOGGLE_BUTTONS_TEXT}
                    withBorderRadius
                    isShrinkable
                    selected={toggleBtnTextActive}
                    onClick={setToggleBtnTextActive}
                />
                <ToggleButtonRow
                    btns={TOGGLE_BUTTONS_ICONS}
                    selected={toggleBtnIconActive}
                    onClick={setToggleBtnIconActive}
                />
            </Container>

            <Container className={'bg-basePrimary py-3 d-flex flex-column align-items-center gap-3 mb-3'}>
                <Typography variant={'h1'}>{intl.formatMessage({ id: 'demo.typography' })}</Typography>
                <Typography variant={'buttonPrimary'}>{'Button Primary'}</Typography>
                <Typography variant={'buttonSecondary'}>{'Button Secondary'}</Typography>
                <Typography variant={'buttonSmall'}>{'Button Small'}</Typography>
                <Typography variant={'linkDefault'}>{'Link Default'}</Typography>
                <Typography variant={'linkDefaultActive'}>{'Link Default Active'}</Typography>
                <Typography variant={'linkSmall'}>{'Link Small'}</Typography>
                <Typography variant={'linkSmallActive'}>{'Link Small Active'}</Typography>
                <Typography variant={'formLabel'}>{'Form Label'}</Typography>
                <Typography variant={'formText'}>{'Form Text'}</Typography>
                <Typography variant={'formDescription'}>{'Form Description'}</Typography>
                <Typography variant={'tableLabel'}>{'Form Label'}</Typography>
                <Typography variant={'tableText'}>{'Table Text'}</Typography>
                <Typography variant={'tableTextBold'}>{'Table Text Bold'}</Typography>
                <Typography variant={'badge'}>{'Badge'}</Typography>
                <Typography variant={'label'}>{'Label'}</Typography>
                <Typography variant={'labelBold'}>{'Label Bold'}</Typography>
                <Typography variant={'desc'}>{'Description'}</Typography>
                <Typography variant={'heroLarge'}>{'Hero Large'}</Typography>
                <Typography variant={'hero'}>{'Hero'}</Typography>
                <Typography variant={'sectionHeadline'}>{'Section Headline'}</Typography>
                <Typography variant={'labelHeadline'}>{'Label Headline'}</Typography>
                <Typography variant={'body'}>{'Body'}</Typography>
                <Typography variant={'bodyBold'}>{'Body Bold'}</Typography>
                <Typography variant={'containerXlHeadline'}>{'Container XL Headline'}</Typography>
                <Typography variant={'containerXlBody'}>{'Container XL Body'}</Typography>
                <Typography variant={'containerLHeadline'}>{'Container L Headline'}</Typography>
                <Typography variant={'containerLBody'}>{'Container L Body'}</Typography>
                <Typography variant={'containerMHeadline'}>{'Container M Headline'}</Typography>
                <Typography variant={'containerMBody'}>{'Container M Body'}</Typography>
                <Typography variant={'containerSHeadline'}>{'Container S Headline'}</Typography>
                <Typography variant={'containerSBody'}>{'Container S Body'}</Typography>
                <Typography variant={'h1'}>{'Headline 1'}</Typography>
                <Typography variant={'h2'}>{'Headline 2'}</Typography>
                <Typography variant={'h3'}>{'Headline 3'}</Typography>
                <Typography variant={'h4'}>{'Headline 4'}</Typography>
                <Typography variant={'h5'}>{'Headline 5'}</Typography>
                <Typography variant={'h6'}>{'Headline 6'}</Typography>
                <Typography variant={'subtitle'}>{'Subtitle'}</Typography>
                <Typography variant={'p'}>{'Paragraph'}</Typography>
                <Typography variant={'pBold'}>{'Paragraph Bold'}</Typography>
                <Typography variant={'pLink'}>{'Paragraph Link'}</Typography>
                <Typography variant={'span'}>{'Span'}</Typography>
            </Container>
        </div>
    )
}

export default Demo
